import { AccommodationTileModel } from '@app/models/elastic-search';
import { accommodationTileDataMock } from '@app/services/__mocks__/listing.mock';
import { ApiServiceBase } from '@app/services/abstracts/api-service.base';

export class ApiListingService extends ApiServiceBase {
    private static _instance: ApiListingService;

    public static get instance(): ApiListingService {
        if (!this._instance) {
            this._instance = new ApiListingService();
        }

        return this._instance;
    }

    public async getListingItem(): Promise<AccommodationTileModel> {
        // TODO: When backend is ready, replace mock with real API call:
        // For now, return mock data with the requested accommodationId
        return Promise.resolve({
            ...accommodationTileDataMock,
        } as unknown as AccommodationTileModel);
    }
}
